// extracted by mini-css-extract-plugin
export var form = "_3k-0";